import { cookieStorage, makePersisted } from "@solid-primitives/storage";
import { Xid } from "@storytell/id";
import type { Logger } from "@storytell/logger";
import { createSignal } from "solid-js";
import { isServer } from "solid-js/web";

export type Dependencies = {
  logger: Logger;
  variant: "extension" | "app";
};

export interface DeviceService {
  getDeviceId: () => string;
}

const UNKNOWN_DEVICE_ID = "device_coepl4pt7098rgkd7ov0";

// useDeviceService provides behaviors to identify a unique device.
// The ID is persisted to the client using cookies.
export const useDeviceService = (deps: Dependencies): DeviceService => {
  const [getDeviceId, setDeviceId] = makePersisted(createSignal<string>(), {
    name: "st_did",
    storage: cookieStorage,
    storageOptions: { expires: new Date(+new Date() + 3.1536e12) }, // 100-years
  });

  if ((isServer || deps.variant === "extension") && !getDeviceId()) {
    setDeviceId(`device_${new Xid().toString()}`);
  }

  return {
    getDeviceId: () => {
      return getDeviceId() ?? UNKNOWN_DEVICE_ID;
    },
  };
};
